import React, { useEffect, useState } from "react";
import DashboardLayout from "../DashboardLayout";
import apiClient from "../../utils/apiClient";

import {
  Tabs,
  TabsContent,
  TabsList,
  TabsTrigger,
} from "../../components/ui/tabs";



import StockOptionsMultiplier from "./StocksOptionsMultiplier/StockOptionsMultiplier";
import IndexptionsMultiplier from "./IndexOptionsMultiplier/IndexOptionsMultiplier";
import NiftyVixConfig from "./NiftyVixConfig/NiftyVixConfig";
import BankNiftyVixConfig from "./BankNiftyVixConfig/BankNiftyVixConfig";
// import BankNiftyRegimeConfig from "./BankNiftyRegimeConfig/BankNiftyRegimeConfig";
import NiftyRegimeConfig from "./NiftyRegimeConfig/NiftyRegimeConfig";
import AdditionalStockUnderlyings from "./AdditionalStocksUnderlying/AdditionalStockUnderlyings";
import VMAData from "./VMA/vmaData";
import FyersUserList from "./FyersUsersList/fyersUser";
import RegimeData from "./RegimeData/regimeData";
import OptimusToggleData from "./OptimusToggles/optimusData";
import SignalUpdateData from "./SignalUpdateData/SignalUpdateData";

export default function BotConfig() {
  useEffect(() => {}, []);

  return (
    <DashboardLayout>
      <div className="flex flex-col relative  w-full min-h-screen font-urbanist">
        <main className="flex flex-1 overflow-hidden flex-col w-full h-full  transition-all duration-300 ease-in-out ">
          <div>
            <div className="flex w-full h-full ">
              <Tabs defaultValue="fyers-users-list" className="w-full ">
                <div className="flex px-6 py-2">
                  <TabsList className=" flex space-x-[6px] ">
                    <TabsTrigger
                      className="text-[15px] "
                      value="fyers-users-list"
                    >
                      Fyers Users
                    </TabsTrigger>
                    <TabsTrigger
                      className="text-[15px]"
                      value="stocks-muliplier"
                    >
                      Stocks Multiplier
                    </TabsTrigger>
                    <TabsTrigger
                      className="text-[15px]"
                      value="index-muliplier"
                    >
                      Index Multiplier
                    </TabsTrigger>
                    {/* <TabsTrigger
                      className="text-[15px]"
                      value="nifty-lot-config"
                    >
                      NF_VIX Lot Config
                    </TabsTrigger> */}
                    {/* <TabsTrigger
                      className="text-[15px]"
                      value="banknifty-lot-config"
                    >
                      BNF_VIX Lot Config
                    </TabsTrigger> */}

                    <TabsTrigger
                      className="text-[15px]"
                      value="additional-stocks"
                    >
                      Additonal Stocks Underlying
                    </TabsTrigger>
                    {/* <TabsTrigger className="text-[15px]" value="vma-table">
                      VMA Table
                    </TabsTrigger> */}
                     <TabsTrigger className="text-[15px]" value="regime-table">
                      Regime Table
                    </TabsTrigger>
                     <TabsTrigger className="text-[15px]" value="signal-update">
                      Signal Update
                    </TabsTrigger>
                     <TabsTrigger className="text-[15px]" value="regime-nifty">
                      Nifty Regime
                    </TabsTrigger>
                    <TabsTrigger className="text-[15px]" value="optimus-toggle">
                      Optimus Toggles
                    </TabsTrigger>
                  </TabsList>
                </div>
                <TabsContent
                  value="fyers-users-list"
                  className="mt-[20px] w-full rounded-md "
                >
                  <FyersUserList />
                </TabsContent>
                <TabsContent
                  value="stocks-muliplier"
                  className="mt-[20px] w-full rounded-md "
                >
                  <StockOptionsMultiplier />
                </TabsContent>
                <TabsContent
                  value="index-muliplier"
                  className="mt-[20px] w-full rounded-md "
                >
                  <IndexptionsMultiplier />
                </TabsContent>
                {/* <TabsContent
                  value="nifty-lot-config"
                  className="mt-[20px] w-full rounded-md "
                >
                  <NiftyVixConfig />
                </TabsContent> */}
                {/* <TabsContent
                  value="banknifty-lot-config"
                  className="mt-[20px] w-full rounded-md "
                >
                  <BankNiftyVixConfig />
                </TabsContent> */}
                <TabsContent
                  value="additional-stocks"
                  className="mt-[20px] w-full rounded-md "
                >
                  <AdditionalStockUnderlyings />
                </TabsContent>
                {/* <TabsContent
                  value="vma-table"
                  className="mt-[20px] w-full rounded-md "
                >
                  <VMAData />
                </TabsContent> */}
                 <TabsContent
                  value="regime-table"
                  className="mt-[20px] w-full rounded-md "
                >
                  <RegimeData />
                </TabsContent>

                 <TabsContent
                  value="signal-update"
                  className="mt-[20px] w-full rounded-md "
                >
                  <SignalUpdateData />
                </TabsContent>

                <TabsContent
                  value="regime-nifty"
                  className="mt-[20px] w-full rounded-md "
                >
                  <NiftyRegimeConfig />
                </TabsContent>

                 <TabsContent
                  value="optimus-toggle"
                  className="mt-[20px] w-full rounded-md "
                >
                  <OptimusToggleData />
                </TabsContent>

              </Tabs>
            </div>
          </div>
        </main>
      </div>
    </DashboardLayout>
  );
}
